var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.03125,
    y: 19.4305,
    width: 11.9373,
    height: 1.56963,
    rx: 0.784816,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82666 8.44195V13.8839H17.1725V8.44195C17.1725 5.4365 14.8565 3 11.9996 3C9.14271 3 6.82666 5.4365 6.82666 8.44195ZM15.7795 8.4418V12.4186H8.21906V8.4418C8.21906 6.24545 9.91153 4.46497 11.9993 4.46497C14.0871 4.46497 15.7795 6.24545 15.7795 8.4418Z",
    fill: "#637282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37512 9.1316C5.73722 8.75067 6.45028 8.44202 6.96279 8.44202H17.0413C17.5533 8.44202 18.2622 8.75116 18.6243 9.1316L21.7894 12.4613C22.1515 12.8423 22.0355 13.2129 21.5271 13.2891L14.8329 14.2952C13.2684 14.5306 10.7291 14.5301 9.16603 14.2952L2.47228 13.2891C1.96533 13.2129 1.84835 12.8423 2.20998 12.4613L5.37512 9.1316Z",
    fill: "#637282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmgIcon);
export default __webpack_public_path__ + "static/media/dmg-icon.8e884ce3.svg";
export { ForwardRef as ReactComponent };